<template>
  <va-edit-layout :actions="['list', 'show', 'delete']">
    <irrigations-form :id="id" :title="title" :item="item"></irrigations-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ['id', 'title', 'item'],
}
</script>
